import { createSelector } from "reselect";
import { getStoreEntity } from "services/store";
import { maintenancePolicyDetailsFetcher } from "state/clusterdefinitions/services/templates";
import { presentLayer } from "utils/presenters";
import { ClusterProfileTemplateSchema } from "utils/schemas";

export const getSelectedMaintenancePolicyDetails = createSelector(
  maintenancePolicyDetailsFetcher.selector,
  ({ result = {} }) => {
    return result;
  }
);

function formatPacks(packs) {
  return packs.map((pack) => {
    return {
      ...pack,
      type:
        pack?.layer === "addon"
          ? pack?.addonType ||
            pack?.spec?.addonSubType ||
            pack?.spec?.addonType ||
            pack?.type
          : pack?.layer,
    };
  });
}

export function formatLinkedProfiles(profilesGuids) {
  const entities =
    getStoreEntity(profilesGuids, [ClusterProfileTemplateSchema]) || [];
  const profileTypePriority = ["cluster", "infra", "add-on"];
  return (entities || [])
    .map(({ profile }) => {
      const packs = formatPacks(profile.spec?.published?.packs || []);
      return {
        ...profile,
        spec: {
          ...profile.spec,
          published: {
            ...profile.spec?.published,
            packs,
          },
        },
        layers: packs.map(presentLayer),
      };
    })
    .sort((profileA, profileB) => {
      const profileTypeA = profileA.spec?.published?.type;
      const profileTypeB = profileB.spec?.published?.type;
      return (
        profileTypePriority.indexOf(profileTypeB) -
        profileTypePriority.indexOf(profileTypeA)
      );
    });
}
